var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageCb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.53467 4.0625C3.08617 4.0625 2.72217 3.6985 2.72217 3.25C2.72217 2.8015 3.08617 2.4375 3.53467 2.4375C3.98317 2.4375 4.34717 2.8015 4.34717 3.25C4.34717 3.6985 3.98317 4.0625 3.53467 4.0625ZM3.53467 1.625C2.63726 1.625 1.90967 2.35259 1.90967 3.25C1.90967 4.14741 2.63726 4.875 3.53467 4.875C4.43207 4.875 5.15967 4.14741 5.15967 3.25C5.15967 2.35259 4.43207 1.625 3.53467 1.625ZM12.4722 6.95825L10.0347 4.46875L5.99613 8.57634L4.34717 6.90625L1.09717 9.88691V1.625C1.09717 1.1765 1.46117 0.8125 1.90967 0.8125H11.6597C12.1082 0.8125 12.4722 1.1765 12.4722 1.625V6.95825ZM12.4722 11.375C12.4722 11.8235 12.1082 12.1875 11.6597 12.1875H9.56017L6.56691 9.15485L10.0347 5.68709L12.4722 8.12459V11.375ZM1.90967 12.1875C1.46117 12.1875 1.09717 11.8235 1.09717 11.375V10.9935L4.32483 8.10266L8.41008 12.1875H1.90967ZM11.6597 0H1.90967C1.01226 0 0.284668 0.727594 0.284668 1.625V11.375C0.284668 12.2724 1.01226 13 1.90967 13H11.6597C12.5571 13 13.2847 12.2724 13.2847 11.375V1.625C13.2847 0.727594 12.5571 0 11.6597 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageCb);
export default __webpack_public_path__ + "static/media/image-cb.4856b315fdb93a2737c8c87d960615a6.svg";
export { ForwardRef as ReactComponent };